module.exports = __webpack_public_path__ + "static/projekt-etykiety-nadbuzanskie-8b577c0aae40e64c3a51d2b417a84201.png";